import { BaseDto } from "src/dtos/common/baseDto";
import {
	SalOrderHdrDto,
	defaultSalOrderHdrDto,
	SalOrderDtlDto,
	defaultSalOrderDtlDto,
} from "src/dtos/salorder/salOrderDto";

/**
 * 수주 헤더 DTO
 * 공통 수주헤더 DTO(SalOrderHdrDto) 확장 + SAL1020 전용 필드
 */
export interface SAL1020_R01HeaderDto extends SalOrderHdrDto {
	logicCenterNm: string;		// 물류센터명
	vatTypeNm: string;			// 부가세구분명
}

export const defaultSAL1020_R01HeaderDto: SAL1020_R01HeaderDto = {
	...defaultSalOrderHdrDto,
	logicCenterNm: '',
	vatTypeNm: '',
};

/**
 * 수주 상세 DTO
 * 공통 수주 상세 DTO(SalOrderDtlDto) 확장 + SAL1020 전용 필드
 */
export interface SAL1020_R01DetailDto extends SalOrderDtlDto {
	modelNo: string;				// 품번
	brandCd: string;			// 브랜드코드
	brandNm: string;			// 브랜드명
	itemUnitNm: string;			// 품목기본단위명
	orderUnitNm: string;		// 주문단위명
	itemGroup: string;			// 품목분류코드
	itemGroupNm: string;		// 품목분류명
	itemAccount: string;		// 품목계정코드
	itemAccountNm: string;		// 품목계정명
}

export const defaultSAL1020_R01DetailDto: SAL1020_R01DetailDto = {
	...defaultSalOrderDtlDto,
	modelNo: '',
	brandCd: '',
	brandNm: '',
	itemUnitNm: '',
	orderUnitNm: '',
	itemGroup: '',
	itemGroupNm: '',
	itemAccount: '',
	itemAccountNm: '',
}

